import { render, staticRenderFns } from "./SetupDefaults.vue?vue&type=template&id=376481e5&scoped=true&"
import script from "./SetupDefaults.vue?vue&type=script&lang=js&"
export * from "./SetupDefaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376481e5",
  null
  
)

export default component.exports